import { render, staticRenderFns } from "./PromoApp.vue?vue&type=template&id=71c3572e&scoped=true&"
import script from "./PromoApp.vue?vue&type=script&lang=js&"
export * from "./PromoApp.vue?vue&type=script&lang=js&"
import style0 from "./PromoApp.vue?vue&type=style&index=0&id=71c3572e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c3572e",
  null
  
)

export default component.exports